// Still on offer, so a placed selection can be re-bet or shared. A suspend is
// temporary and a live market trades like any other; whether this USER may bet
// it is the betslip's call.
export const isMarketOpenForBets = (status: string) => {
  return ["ACTIVE", "OPEN", "SUSPENDED", "LIVE"].includes(status);
};
